module.exports = __webpack_public_path__ + "ENG_SPT11-Pool_225002889-32f36ec75d6d1f80ff977cf118f96620.png";